export function reportBootstrapFailure(error, target = document.body) {
  console.error('[kUni] frontend bootstrap failed', error);
  document.documentElement.classList.remove('kuni-app-boot', 'kuni-join-boot', 'kuni-boot-visible');
  const existing = document.querySelector('[data-kuni-bootstrap-error]');
  if (existing) return;
  const box = document.createElement('div');
  box.dataset.kuniBootstrapError = '1';
  box.setAttribute('role', 'alert');
  box.style.cssText = 'position:fixed;inset:20px;z-index:2147483647;margin:auto;max-width:560px;height:max-content;padding:20px;border-radius:16px;background:#171a20;color:#f6f7f9;font:14px/1.5 system-ui;box-shadow:0 18px 60px #0008';
  box.innerHTML = '<strong style="display:block;font-size:18px;margin-bottom:8px">Не удалось запустить kUni</strong><span>Обновите страницу. Если ошибка повторяется, проверьте консоль браузера.</span>';
  target.appendChild(box);
}

export async function loadVendorScript(src) {
  const existing = document.querySelector(`script[data-kuni-vendor="${src}"]`);
  if (existing?.dataset.loaded === '1') return;
  if (existing) {
    await new Promise((resolve, reject) => {
      existing.addEventListener('load', resolve, { once: true });
      existing.addEventListener('error', reject, { once: true });
    });
    return;
  }
  await new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = false;
    script.dataset.kuniVendor = src;
    script.addEventListener('load', () => {
      script.dataset.loaded = '1';
      resolve();
    }, { once: true });
    script.addEventListener('error', () => reject(new Error(`Failed to load ${src}`)), { once: true });
    document.head.appendChild(script);
  });
}
